/* Paw Tones storefront script. Reads window.PT (set in layout/theme.liquid). */
(function () {
  var PT = window.PT || {};
  var CFG = {
    unit: PT.unit || 2000,
    shipPrice: PT.shipPrice || 399,
    warrPrice: PT.warrPrice || 399,
    etaMin: 7, etaMax: 17,
    replyTime: "within 1 business day",
    tiers: [
      { qty: 1, pct: 0 },
      { qty: 2, pct: 10, badge: "Most popular" },
      { qty: 3, pct: 15 },
      { qty: 4, pct: 20, badge: "Best value" }
    ],
    sizes: [
      { id: "S", label: "S (head 25-38 cm)" },
      { id: "M", label: "M (head 35-48 cm)" },
      { id: "L", label: "L (head 45-60 cm)" }
    ],
    colours: [
      { id: "grey", name: "Grey", hex: "#464a50", pos: "96% 50%" },
      { id: "pink", name: "Pink", hex: "#d6337f", pos: "4% 50%" }
    ]
  };
  var page = document.body.getAttribute("data-page") || "home";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function gbp(p) { return "£" + (p / 100).toFixed(2); }
  function tierBase(t) { return Math.round(t.qty * CFG.unit * (100 - t.pct) / 100); }
  function tierFull(t) { return t.qty * CFG.unit; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- toast, drawer, size guide ---------- */
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toast.h); toast.h = setTimeout(function () { t.classList.remove("show"); }, 3600);
  }
  function openSize(show) {
    var m = $("#sizeModal"); if (!m) return;
    m.classList.toggle("show", show); $("#scrim").classList.toggle("show", show);
    m.setAttribute("aria-hidden", String(!show));
    if (show) $("#closeSize").focus();
  }
  function openCart(show) {
    $("#drawer").classList.toggle("show", show); $("#scrim").classList.toggle("show", show);
    $("#drawer").setAttribute("aria-hidden", String(!show));
    if (show) $("#closeCart").focus();
  }

  /* ---------- Shopify cart ---------- */
  var cart = { items: [], item_count: 0, total_price: 0, total_discount: 0 };
  function drawCart() {
    $("#cartN").textContent = cart.item_count || 0;
    $("#cartTotal").textContent = gbp(cart.total_price || 0);
    var sv = $("#cartSave");
    if (sv) { sv.hidden = !(cart.total_discount > 0); sv.textContent = "You are saving " + gbp(cart.total_discount); }
    $("#lines").innerHTML = cart.items.length ? cart.items.map(function (it) {
      var was = it.original_line_price > it.final_line_price;
      var v = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
      return '<div class="line"><div class="r"><span>' + esc(it.product_title) + (it.quantity > 1 ? " × " + it.quantity : "") + '</span><span>' +
        (was ? '<s style="color:var(--muted);font-weight:500;margin-right:6px">' + gbp(it.original_line_price) + '</s>' : "") + gbp(it.final_line_price) + '</span></div>' +
        (v ? '<small>' + esc(v) + '</small>' : "") +
        '<button class="rm" type="button" data-rm="' + esc(it.key) + '">Remove</button></div>';
    }).join("") : '<p class="empty">Your cart is empty.</p>';
    var co = $("#checkout"); co.disabled = !cart.items.length; co.style.opacity = cart.items.length ? 1 : .5;
  }
  function refreshCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; drawCart(); return c; });
  }
  function postJSON(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Could not update cart"); return j; });
    });
  }
  $("#lines").addEventListener("click", function (e) {
    var b = e.target.closest("[data-rm]"); if (!b) return;
    postJSON("/cart/change.js", { id: b.dataset.rm, quantity: 0 }).then(function (c) { cart = c; drawCart(); }).catch(function (err) { toast(err.message); });
  });
  $("#checkout").addEventListener("click", function () { if (cart.items.length) window.location.href = "/checkout"; });
  $("#openCart").addEventListener("click", function () { openCart(true); });
  $("#closeCart").addEventListener("click", function () { openCart(false); });
  $("#scrim").addEventListener("click", function () { openCart(false); openSize(false); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { openCart(false); openSize(false); } });
  var cs = $("#closeSize"); if (cs) cs.addEventListener("click", function () { openSize(false); });
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-sizeguide]")) openSize(true);
    var s = e.target.closest("[data-scroll]");
    if (s) { var t = document.getElementById(s.dataset.scroll); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" }); } }
  });
  var burger = $("#burger");
  burger.addEventListener("click", function () {
    var open = $("#mnav").classList.toggle("open");
    burger.setAttribute("aria-expanded", String(open));
  });
  refreshCart().catch(function () { drawCart(); });
  if (page === "cart") refreshCart().then(function () { openCart(true); });

  /* ---------- delivery and reply text ---------- */
  function fmtDate(d) { return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" }); }
  (function () {
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + CFG.etaMin); b.setDate(b.getDate() + CFG.etaMax);
    var eta = $("#eta"); if (eta) eta.textContent = fmtDate(a) + " to " + fmtDate(b);
    $$(".etaTxt").forEach(function (n) { n.textContent = CFG.etaMin + " to " + CFG.etaMax + " days"; });
    $$(".replyTime").forEach(function (n) { n.textContent = CFG.replyTime; });
  })();

  /* ---------- shop page: gallery + bundle builder ---------- */
  if (page === "shop" && $("#tiers")) {
    var SLIDES = PT.slides || [];
    var state = { tier: 1, units: [], ship: true, warr: true, slide: 0 };
    for (var u = 0; u < 4; u++) state.units.push({ size: "M", colour: u % 2 === 1 ? "pink" : "grey" });

    var drawGallery = function () {
      var img = $("#mainImg"), sl = SLIDES[state.slide];
      if (sl) { img.src = sl.src; img.alt = sl.alt || ""; }
      $$("#thumbs button").forEach(function (b, i) { b.setAttribute("aria-current", i === state.slide ? "true" : "false"); });
    };
    $("#thumbs").innerHTML = SLIDES.map(function (sl, i) {
      return '<button type="button" data-s="' + i + '" aria-label="Show image ' + (i + 1) + '"><img src="' + esc(sl.thumb) + '" alt="" width="140" height="140" loading="lazy"></button>';
    }).join("");
    $("#thumbs").addEventListener("click", function (e) { var b = e.target.closest("button"); if (!b) return; state.slide = +b.dataset.s; drawGallery(); });
    var stepGallery = function (d) { if (!SLIDES.length) return; state.slide = (state.slide + d + SLIDES.length) % SLIDES.length; drawGallery(); };
    $("#galPrev").addEventListener("click", function () { stepGallery(-1); });
    $("#galNext").addEventListener("click", function () { stepGallery(1); });

    var mini = function (colId) {
      var c = CFG.colours.filter(function (x) { return x.id === colId; })[0] || CFG.colours[0];
      return '<i class="mini" style="background-image:url(' + (PT.mini || "") + ');background-position:' + c.pos + ';background-color:' + c.hex + '"></i>';
    };
    var ICON_SHIELD = '<svg class="i" viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
    var ICON_WARRANTY = '<svg class="i" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.2l2.4 2.4 4.6-5"/></svg>';

    var unitHTML = function (i) {
      var un = state.units[i];
      return '<div class="unit" data-u="' + i + '"><div class="unit-art">' + mini(un.colour) + '</div>' +
        '<div class="unit-main"><span class="unit-label">Cover ' + (i + 1) + '</span><div class="unit-opts">' +
        '<select data-size="' + i + '" aria-label="Cover ' + (i + 1) + ' size">' +
        CFG.sizes.map(function (s) { return '<option value="' + s.id + '"' + (s.id === un.size ? " selected" : "") + '>' + s.label + '</option>'; }).join("") +
        '</select><div class="sw" role="group" aria-label="Cover ' + (i + 1) + ' colour">' +
        CFG.colours.map(function (c) { return '<button type="button" data-col="' + c.id + '" data-u="' + i + '" aria-pressed="' + (c.id === un.colour) + '"><i style="background:' + c.hex + '"></i>' + c.name + '</button>'; }).join("") +
        '</div></div></div></div>';
    };
    var tierHTML = function (t, idx) {
      var save = tierFull(t) - tierBase(t);
      var title = t.qty + " pack" + (t.pct ? " - " + t.pct + "% OFF" : "");
      var sub = t.pct ? "You save " + gbp(save) : "Standard price";
      var units = ""; for (var i = 0; i < t.qty; i++) units += unitHTML(i);
      return '<div class="tier' + (t.badge ? " has-badge" : "") + '" data-t="' + idx + '">' +
        (t.badge ? '<span class="badge">' + t.badge + '</span>' : "") +
        '<label class="tier-head"><input class="sr-only" type="radio" name="tier" value="' + idx + '"><span class="radio" aria-hidden="true"></span>' +
        '<span class="tier-title"><b>' + title + '</b><small>' + sub + '</small></span>' +
        '<span class="tier-price"><b>' + gbp(tierBase(t)) + '</b>' + (t.pct ? '<s>' + gbp(tierFull(t)) + '</s>' : "") + '</span></label>' +
        '<div class="tier-body">' + units + '</div>' +
        '<div class="ups">' +
        '<label class="up"><span class="thumb">' + ICON_SHIELD + '</span><span class="t">+ Add Shipping Protection</span><span class="p">' + gbp(CFG.shipPrice) + '</span><input type="checkbox" data-up="ship" aria-label="Add Shipping Protection"></label>' +
        '<label class="up"><span class="thumb">' + ICON_WARRANTY + '</span><span class="t">+ Add 30 Day Warranty</span><span class="p">' + gbp(CFG.warrPrice) + '</span><input type="checkbox" data-up="warr" aria-label="Add 30 Day Warranty"></label>' +
        '</div></div>';
    };
    $("#tiers").innerHTML = CFG.tiers.map(tierHTML).join("");

    var totals = function () {
      var t = CFG.tiers[state.tier];
      var up = (state.ship ? CFG.shipPrice : 0) + (state.warr ? CFG.warrPrice : 0);
      return { t: t, total: tierBase(t) + up };
    };
    var tierName = function (t) { return t.qty + " pack" + (t.pct ? " (" + t.pct + "% off)" : ""); };
    var extras = function () { var a = []; if (state.ship) a.push("Shipping Protection"); if (state.warr) a.push("30 Day Warranty"); return a; };
    var sync = function () {
      var tt = totals();
      $$(".tier").forEach(function (el) {
        var on = +el.dataset.t === state.tier;
        el.classList.toggle("on", on); $("input[name=tier]", el).checked = on;
      });
      $$("select[data-size]").forEach(function (s) { s.value = state.units[+s.dataset.size].size; });
      $$(".sw button").forEach(function (b) { b.setAttribute("aria-pressed", String(state.units[+b.dataset.u].colour === b.dataset.col)); });
      $$(".unit").forEach(function (el) { $(".unit-art", el).innerHTML = mini(state.units[+el.dataset.u].colour); });
      $$("input[data-up]").forEach(function (c) { c.checked = state[c.dataset.up]; });
      $("#addBtn").textContent = "Add to cart · " + gbp(tt.total);
      $("#stTotal").textContent = gbp(tt.total);
      $("#stSub").textContent = tierName(tt.t);
      var ex = extras();
      $("#ctaNote").textContent = tt.t.qty + (tt.t.qty > 1 ? " covers" : " cover") + (ex.length ? " + " + ex.join(" + ") : "");
    };
    var setTier = function (i) { state.tier = i; sync(); };
    var tiersEl = $("#tiers");
    tiersEl.addEventListener("click", function (e) {
      var el = e.target.closest(".tier"); if (!el) return;
      if (!el.classList.contains("on")) { e.preventDefault(); setTier(+el.dataset.t); }
    });
    tiersEl.addEventListener("change", function (e) {
      var t = e.target;
      if (t.matches("input[name=tier]")) setTier(+t.value);
      else if (t.matches("select[data-size]")) { state.units[+t.dataset.size].size = t.value; sync(); }
      else if (t.matches("input[data-up]")) { state[t.dataset.up] = t.checked; sync(); }
    });
    tiersEl.addEventListener("click", function (e) {
      var b = e.target.closest(".sw button"); if (!b) return;
      state.units[+b.dataset.u].colour = b.dataset.col;
      state.slide = b.dataset.col === "pink" ? 1 : 0; drawGallery(); sync();
    });

    var adding = false;
    var addToCart = function () {
      if (adding) return;
      var tt = totals(), counts = {}, items = [];
      state.units.slice(0, tt.t.qty).forEach(function (un) {
        var id = (PT.v || {})[un.colour + "-" + un.size.toLowerCase()];
        if (id) counts[id] = (counts[id] || 0) + 1;
      });
      Object.keys(counts).forEach(function (id) { items.push({ id: +id, quantity: counts[id] }); });
      if (!items.length) { toast("Sorry, this product is not available right now."); return; }
      if (state.ship && PT.ship) items.push({ id: PT.ship, quantity: 1 });
      if (state.warr && PT.warr) items.push({ id: PT.warr, quantity: 1 });
      adding = true; $("#addBtn").disabled = true;
      postJSON("/cart/add.js", { items: items }).then(refreshCart).then(function () { openCart(true); })
        .catch(function (err) { toast(err.message); })
        .then(function () { adding = false; $("#addBtn").disabled = false; });
    };
    $("#addBtn").addEventListener("click", addToCart);
    $("#stBtn").addEventListener("click", addToCart);
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-jump]")) $("#tiers").scrollIntoView({ behavior: "smooth", block: "center" });
    });

    /* sticky buy bar (shop page only) */
    var stick = $("#sticky"), ctaVisible = true;
    var updateSticky = function () {
      var show = !ctaVisible && window.scrollY > 300;
      stick.classList.toggle("show", show);
      stick.setAttribute("aria-hidden", String(!show));
      $("#stBtn").tabIndex = show ? 0 : -1;
    };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; updateSticky(); }).observe($("#addBtn"));
    }
    window.addEventListener("scroll", updateSticky, { passive: true });
    drawGallery(); sync();
  }

  /* highlight current nav link */
  var cur = { home: "/", shop: "/products/", faq: "/pages/faq", contact: "/pages/contact" }[page];
  if (cur) $$(".nav a, .mnav a").forEach(function (a) { var h = a.getAttribute("href"); if (h === cur || (page === "shop" && h.indexOf("/products/") === 0)) a.setAttribute("aria-current", "page"); });
})();
